import React from "react";
import ReactDOM from "react-dom";
import { Amplify } from "aws-amplify";
import awsconfig from "./aws-exports";

import "./style/index.css";
import { BrowserRouter } from "react-router-dom";
import App from "./App";

// 配置 AWS Amplify
const amplifyConfig = {
  ...awsconfig,
  Auth: {
    ...awsconfig.Auth,
    // 強制禁用本地認證
    localAuthConfig: {
      enabled: false,
    },
  },
};

Amplify.configure(amplifyConfig);

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);
